export const IS_PLAY_BAR_DISPLAYED = "IS_PLAY_BAR_DISPLAYED";
export const TRACK_OBJECT = "TRACK_OBJECT";
export const SET_POSITION_IN_HISTORY = "SET_POSITION_IN_HISTORY";
export const RELOAD_FETCH = "RELOAD_FETCH";
